<script lang="ts" setup>
import { defineAsyncComponent, watch } from 'vue'
import { useField } from 'vee-validate'
import '@vueform/slider/themes/default.css'

const props = withDefaults(
  defineProps<{
    format?: any
    lazy?: boolean
    tooltips?: boolean
    tooltipText?: StoryBlokRichText
    tooltipLabel?: string
    step?: number
    max: number
    min: number
    rules?: string
    name: string
    label?: string
    range?: Record<string, number | number[]>
    hideErrors?: boolean
    tooltip?: any
    currency: string
  }>(),
  {
    tooltips: true,
  },
)

const emit = defineEmits(['update:modelValue', 'change'])

const appConfig = useAppConfig()
const VueSlider = defineAsyncComponent(() => import('@vueform/slider'))
const options = {
  step: props.step || 1,
  range: {
    min: props.min,
    ...props.range,
    max: props.max,
  },
}
const { value } = useField<number>(props.name, props.rules)
watch(
  () => props.min,
  (val) => {
    options.range = {
      min: val,
      ...props.range,
      max: options.range.max,
    }
    if (value.value < val) value.value = val
  },
)
watch(
  () => props.max,
  (val) => {
    options.range = {
      min: options.range.min,
      ...props.range,
      max: val,
    }
    if (value.value > val) value.value = val
  },
)

watch(
  () => value.value,
  (val) => {
    emit('update:modelValue', val)
  },
)
</script>

<template>
  <div class="flex flex-col">
    <div class="w-full">
      <div class="flex items-center gap-5">
        <div class="w-full mt-2.5">
          <ClientOnly>
            <VueSlider v-bind="$props" v-model="value" class="slider" :options="options" tooltip-position="bottom" @change="$emit('change', $event)" />
          </ClientOnly>
        </div>
      </div>
    </div>
    <div class="flex flex-row justify-between mt-2.5">
      <span class="text-sm">{{ min.toLocaleString(appConfig.locale.code) }} {{ currency }}</span>
      <span class="text-sm">{{ max.toLocaleString(appConfig.locale.code) }} {{ currency }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.slider {
  & > :deep(.slider-base) {
    --slider-handle-width: 24px;
    --slider-handle-height: 24px;
    --slider-tooltip-bg: rgba(0, 0, 0, 0);
    --slider-tooltip-color: #201c46;
    --slider-tooltip-font-weight: 400;
    --slider-tooltip-font-size: 16px;
    --slider-tooltip-line-height: 24px;
    --slider-handle-ring-width: 2px;
    --slider-handle-ring-color: #CACACA;
    @apply bg-primary bg-opacity-15;
    & > .slider-connects {
      .slider-connect {
        @apply bg-primary;
      }
    }
  }
}
</style>
